import {
  Action,
  ThunkAction,
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import vendorUserReducer from "../auth/VendorAuth/vendorUserSlice";
import appConfigReducer from "./appConfigSlice";
import confirmModalReducer from "./confirmModalSlice";
import elementLibraryModalReducer from "./elementLibrarySlice";
import errorModalReducer from "./errorModalSlice";
import rfiReducer from "./rfiSlice";
import timeoutModalReducer from "./timeoutModalSlice";
import vendorResponseReducer from "./vendorResponseSlice";

import { persistReducer, persistStore } from "redux-persist";
import ThunkExtraArguments from "types/ThunkExtraArguements";

// ONLY rfiId needs to be persisted so login callback knows what appconfig to get
// if isAuthContextConfigured is persisted it will break
const persistedVendorUserReducer = persistReducer(
  { key: "vendorUser", storage, whitelist: ["rfiId"] },
  vendorUserReducer
);

const rootReducer = combineReducers({
  appConfig: appConfigReducer,
  rfi: rfiReducer,
  errorModal: errorModalReducer,
  timeoutModal: timeoutModalReducer,
  confirmModal: confirmModalReducer,
  elementLibraryModal: elementLibraryModalReducer,
  vendorUser: persistedVendorUserReducer,
  vendorResponse: vendorResponseReducer,
});

const thunkArguments = {} as ThunkExtraArguments;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: {
        extraArgument: thunkArguments,
      },
    }),
});

thunkArguments.store = store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const persistor = persistStore(store);

export default store;
